<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'slug', 'website'],
    data() {
      return {
        default_content: {
          type: 'preferred-partners',
          title: 'Preferred Partners',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '10',
          pad_l: '0',
          icon: '',
          icon_color: '',
          h2: '',
          h2_color: '',
          h2_desc: '',
          h2_desc_color: '',
          pre_btn: [],

          main_bg_color: 'white',
          main_border_color: '',
          main_title: 'Interested?',
          main_title_color: 'black',
          main_desc: "If you're interested fill out the form below and we will send you additional details.",
          main_text_color: 'muted',
          main_btn_color: 'revinre',
          main_btn_pre_icon: 'ri:mail-send-line',
          main_btn_text: 'Submit',
          main_btn_post_icon: '',
          main_icon: 'ri:building-4-line',
          main_icon_color: 'revinre',
          main_image: '/storage/fm/revinre-nc/clip art/Contact Preferred Partner.png',

          loc_active: 1,
          loc_icon: 'ri:road-map-line',
          loc_top_bg_color: 'dark',
          loc_top_text_color: 'white',
          loc_bg_color: 'white',
          loc_text_color: 'black',

          cat_active: 1,
          cat_icon: 'ri:price-tag-3-line',
          cat_top_bg_color: 'dark',
          cat_top_text_color: 'white',
          cat_bg_color: 'white',
          cat_text_color: 'black',

          post_btn: [],
        },

        blog_url: '/',

        loading: true,
        results: [],
        pagination: {},
        filters: {
          paginate: 1000,
          page: 1,
          total: 0,
        },

        search: '',
        locations: [],
        categories: [],
        seen: [],
        message_sent: [],
        contactform: {
          name: '',
          email: '',
          phone: '',
          vendor: '',
          comments: "I would like more information on this please!",
          // buying: false,
          // has_realtor: false,
          recaptcha_token: '',
        },
      }
    },
    watch: {
      'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
    },
    computed: {
      computedResults() {
        console.log('computedResults');
        var results = [], a_locations = [], a_categories = [];

        var locations_allfalse = true; for(var i in this.locations) { if(this.locations[i].active) { locations_allfalse = false; a_locations.push(this.locations[i].name); } }
        var categories_allfalse = true; for(var i in this.categories) { if(this.categories[i].active) { categories_allfalse = false; a_categories.push(this.categories[i].name); } }

        for(var i in this.results) {
          if((locations_allfalse || this.results[i].locations.some(r=> a_locations.includes(r))) &&
            (categories_allfalse || this.results[i].categories.some(r=> a_categories.includes(r))) &&
            (!this.search || JSON.stringify(this.results[i]).toLowerCase().includes(this.search.toLowerCase()))
          ) {
            results.push(this.results[i]);
          }
        }
        return results;
      },
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }

      if(this.type != 'editor') {
        
        this.locations = [];
        if(this.website['vendor_locations']) { for(var i in this.website['vendor_locations']) {
          this.locations.push({id: (i + 1), name: this.website['vendor_locations'][i], active: false});
        } }
        
        this.categories = [];
        if(this.website['vendor_categories']) { for(var i in this.website['vendor_categories']) {
          this.categories.push({id: (i + 1), name: this.website['vendor_categories'][i], active: false});
        } }

        this.fetchData();
      }
    },
    methods: {
      fetchData() {
        this.loading = true;
        this.filters.page = this.pagination.current_page;
        this.$http.get((this.isAdmin ? '/api' : '')+'/vendors/fetch', {params: this.filters}).then(res => {
          console.log(res);
          this.results = res.data.data;
          this.pagination = res.data;
          this.filters.total = res.data.total;
          this.loading = false;
        }).catch(res => {
          this.loading = false;
          // this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
        });
      },
      toggleShow(test) {
        if(test.height == 200) { test.height = 2000; } else { test.height = 200; }
      }
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Details Box :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.main_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Section border color :" :Options="theme_colors" v-model="pc.main_border_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_title_color" Title="Title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_text_color" Title="Text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_btn_color" Title="Button color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_pre_icon" Title="Button pre icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_text" Title="Button text :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_post_icon" Title="Button post icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_icon" Title="Form icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_icon_color" Title="Form icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_title" Title="Form title :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_desc" Title="Form description :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_image" Title="Form image :"></w-field>
          </div>
        </div>
        
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Location box :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.loc_active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display the blog categories selection field on the right of the blog?"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.loc_icon" Title="Categories icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top background color :" :Options="theme_colors" v-model="pc.loc_top_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top text color :" :Options="theme_colors" v-model="pc.loc_top_text_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom background color :" :Options="theme_colors" v-model="pc.loc_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom text color :" :Options="theme_colors" v-model="pc.loc_text_color"></w-field>
          </div>
        </div>
        
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Category box :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.cat_active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display the blog categories selection field on the right of the blog?"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.cat_icon" Title="Categories icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top background color :" :Options="theme_colors" v-model="pc.cat_top_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top text color :" :Options="theme_colors" v-model="pc.cat_top_text_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom background color :" :Options="theme_colors" v-model="pc.cat_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom text color :" :Options="theme_colors" v-model="pc.cat_text_color"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div v-if="pc['icon'] || pc['h2'] || pc['h2_desc']" class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div v-if="loading && !computedResults.length" class="row">
          <div v-if="pc['cat_active'] || pc['loc_active']" class="col-sm-3">
            <div v-if="pc['loc_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_top_bg_color']+' text-'+pc['cat_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['cat_icon']" /> Locations</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-4">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_bg_color']">
                  <li v-for="c_i in 3" :key="c_i" class="nav-item">
                    <div class="nav-link py-2 border-top border-light" :class="'text-'+pc['cat_text_color']"><div class="ph" style="height: 20px;"></div></div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="pc['cat_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['loc_top_bg_color']+' text-'+pc['loc_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['loc_icon']" /> Categories</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-4">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['loc_bg_color']">
                  <li v-for="c_i in 19" :key="c_i" class="nav-item">
                    <div class="nav-link py-2 border-top border-light" :class="'text-'+pc['cat_text_color']"><div class="ph" style="height: 20px;"></div></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div :class="'col-sm-'+(pc['cat_active'] || pc['loc_active'] ? 9 : 12)">
            <div v-for="c_i in 3" :key="c_i" class="card mb-4" :class="'bg-'+pc['main_bg_color']">
              <div class="card-header p-0" :class="'bg-'+pc['main_bg_color']">
                <div class="p-3">
                  <Icon icon="ri:arrow-down-s-line" class="float-right _f-s-30 _lh-30" />
                  <div class="row m-0">
                    <div class="_w-180">
                      <div class="ph _h-120 rounded"></div>
                    </div>
                    <div class="col">
                      <div class="ph mb-2" style="height: 40px;"></div>
                      <div class="ph mb-2" style="height: 20px;"></div>
                      <div class="ph mb-2" style="height: 20px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="!loading" class="row">
          <div v-if="pc['cat_active'] || pc['loc_active']" class="col-sm-3">
            <div v-if="pc['loc_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['loc_top_bg_color']+' text-'+pc['loc_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['loc_icon']" /> Locations</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-5">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['loc_bg_color']">
                  <li v-if="locations" v-for="(loc, loc_i) in locations" :key="loc_i" class="nav-item">
                    <div class="nav-link py-2 active border-top border-light" :class="'text-'+pc['loc_text_color']" @click="loc.active ? loc.active = false : loc.active = true">
                      <p-check class="p-default p-curve p-smooth w-100" color="success-o" v-model="loc.active"><span class="ml-2">{{ loc.name }}</span></p-check>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="pc['cat_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_top_bg_color']+' text-'+pc['cat_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['cat_icon']" /> Categories</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-5">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_bg_color']">
                  <li v-if="categories" v-for="(cat, cat_i) in categories" :key="cat_i" class="nav-item">
                    <div class="nav-link py-2 active border-top border-light" :class="'text-'+pc['cat_text_color']" @click="cat.active ? cat.active = false : cat.active = true">
                      <p-check class="p-default p-curve p-smooth w-100" color="success-o" v-model="cat.active"><span class="ml-2">{{ cat.name }}</span></p-check>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div :class="'col-sm-'+(pc['cat_active'] || pc['loc_active'] ? 9 : 12)">

            <div class="mb-4">
              <div class="input-group">
                <input class="form-control py-2 border-right-0 border-light _h-50" type="search" placeholder="Search for content..." v-model="search">
                <span class="input-group-append">
                  <div class="input-group-text bg-white border-light"><Icon icon="ri:search-line" class="_f-s-20 mt-0 text-muted" /></div>
                </span>
              </div>
            </div>

            <transition-group id="accordion" name="fade" class="accordion mt-4 mb-5">
              <div v-if="!loading && !computedResults.length" :key="0" class="card p-3" :class="'bg-'+pc['main_bg_color']">
                <div class="card-body p-5 text-center border rounded _b-s-7 _b-dashed" :class="'border-'+pc['main_border_color']">
                  <h3 :class="'text-'+pc['main_title_color']">No results were found</h3>
                  <p class="m-0" :class="'text-'+pc['main_text_color']">Please adjust your filters</p>
                </div>
              </div>
              <div v-for="(item, item_i) in computedResults" :key="item.id" class="card mb-4" :class="'bg-'+pc['main_bg_color']">
                <div class="card-header p-0" :id="'faq-'+item.id"  :class="'border-'+pc['main_border_color']+' bg-'+pc['main_bg_color']">
                  <div class="_c-pointer p-3" data-toggle="collapse" :data-target="'#faq-c-'+item.id" @click="updateViews(item)">
                    <Icon icon="ri:arrow-down-s-line" class="float-right _f-s-30 _lh-30" />
                    <div class="row">
                      <div class="_w-250 p-0">
                        <img :src="formatImage(item.thumbnail)" :alt="item.title" class="rounded">
                      </div>
                      <div class="col-12 col-sm" :class="'small text-'+pc['main_text_color']">
                        <h2 :class="'mb-0 text-'+pc['main_title_color']">{{item.title}}</h2>
                        <p class="small mb-1" >
                          <span v-for="(zet, zet_i) in item.locations" :key="zet_i" class="">{{zet}}{{zet_i != item.locations.length - 1 ? ',':''}} </span>
                        </p>
                        <div class="mb-1">
                          <span v-for="(zet, zet_i) in item.categories" :key="zet_i" class="px-1 mr-1 border rounded small" :class="'border-'+pc['main_border_color']">{{zet}}</span>
                        </div>
                        <p>{{ item['summary'] }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div :id="'faq-c-'+item.id" class="collapse" data-parent="#accordion">
                  <div class="card-body">
                    <div class="" v-html="item.content"></div>
                    <div class="border-top border-light pt-4 mt-4" :class="'border-'+pc['main_border_color']">
                      <div class="text-center _w-m-900 mx-auto">
                        <Icon v-if="pc['main_icon']" :icon="pc['main_icon']" height="45" class="mb-2" :class="'text-'+pc['main_icon_color']"></Icon>
                        <h2 v-if="pc['main_title']" class="mb-3" :class="'text-'+pc['main_title_color']" data-aos="fade-zoom-in">{{pc['main_title']}}</h2>
                        <p v-if="pc['main_desc']" :class="'text-'+pc['main_text_color']" data-aos="fade-zoom-in">{{pc['main_desc']}}</p>
                      </div>
                      <div class="row align-items-center justify-content-center">
                        <div class="col-sm-5 pr-5">
                          <div><img :src="formatImage(pc['main_image'])" alt="Contact Preferred Partner" class="img-fluid mx-auto d-block"></div>
                        </div>
                        <div class="col-sm-6">
                          <div v-if="message_sent.includes(item.id)">
                            <div class="text-center text-success py-5" data-aos="fade-zoom-in">
                              <h3 class="h1 _f-shadow-0-1-2-b-4">Thank You!</h3>
                              <div class="text-muted mb-3">Your message has been sent! We will get back to you shortly.</div>
                              <div class="">
                                <span class="mdi mdi-check-circle-outline _f-s-150 _lh-150 _f-shadow-0-1-2-b-4"></span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <form @submit.prevent="contactus(item)" id="vendor_inquiry">
                              <div class="form-group">
                                <input id="input-name" name="name" placeholder="Full name" type="text" class="form-control _h-40" v-model="contactform.name" required>
                              </div>
                              <div class="form-group">
                                <input id="input-email" name="email" placeholder="Email address" type="text" class="form-control _h-40" v-model="contactform.email" required>
                              </div>
                              <div class="form-group">
                                <the-mask id="input-phone" name="phone" placeholder="Phone number" type="tel" class="form-control _h-40" v-model="contactform.phone" :mask="['(###) ###-####']" required />
                              </div>
                              <div class="form-group">
                                <textarea id="input-comments" name="comments" placeholder="Comments" class="form-control _h-40" rows="2" v-model="contactform.comments" required></textarea>
                              </div>
                              <div class="small">
                                <p class="small font-weight-light mb-1" :class="'text-'+pc['main_text_color']">By submitting you agree to {{app_name}}'s <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms" target="_blank">Terms & Conditions</a>.</p>
                                <p class="small font-weight-light mb-3" :class="'text-'+pc['main_text_color']">This site is protected by ReCaptcha and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</p>
                              </div>
                              <button type="submit" v-if="pc['main_btn_text'] || pc['main_btn_pre_icon'] || pc['main_btn_post_icon']" class="btn btn-block" :class="'btn-'+pc['main_btn_color']">
                                <Icon v-if="pc['main_btn_pre_icon']" :icon="pc['main_btn_pre_icon']" height="20"></Icon>
                                <span v-if="pc['main_btn_pre_icon'] && pc['main_btn_text']" class="border-left mx-3"></span>
                                {{ pc['main_btn_text'] }}
                                <span v-if="pc['main_btn_post_icon'] && pc['main_btn_text']" class="border-left mx-3"></span>
                                <Icon v-if="pc['main_btn_post_icon']" :icon="pc['main_btn_post_icon']" height="20"></Icon>
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
